import React,{useState} from 'react';
import styles from './ForgotPassword.module.scss';
import ResetPassword from './resetPassword';
import ForgotPasswordEmail from './forgotPasswordEmail';
import { Container, Row, Col } from 'react-bootstrap';

const ForgotPassword = (props) => {
    const [state,setState] = useState(1);
    const [mail, setMail] = useState("");

    function Previous(value){
        setState(value);
    }

    function next(value){
        setState(value);
    }

    function setEmail(value){
        setMail(value)
    }

    return (
        <div>
            <Row className={styles.forgotPasswordBackgroundColor}>
                <Container>
                    <Row>
                        <Col md={{ span: 6, offset: 3 }} className={styles.forgotPasswordBoxWrap} >
                            <div className={styles.forgotPasswordBox}>
                                <Container className={styles.innerBoxContainer}>
                                    {
                                        state === 1?
                                            (<ForgotPasswordEmail next={next} setEmail={setEmail}/>)
                                            : (<ResetPassword Previous={Previous} setEmail={mail}/>)
                                    }
                                    
                                </Container>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>
        </div>
    )
}

export default ForgotPassword;
